
import { Options, Vue } from 'vue-class-component';
import { CompanyClient, ProductionPhaseConfigurationClient, ProductionProcessClient } from '@/services/Services';
import EditModal from '../modals/editModal.vue';
import InfoModal from '@/components/modals/infoModal.vue';
import * as OM from '@/Model';

@Options({
    components: {}
})
export default class ProductionProcess extends Vue {

    items: OM.ProductionPhaseConfigurationVM[] = [];
    loaded: boolean = false;

    created() {
        this.init();
    }

    init() {
        ProductionPhaseConfigurationClient.getAllConfigurations()
        .then(x => {
            this.items = x;
            this.loaded = true;
        })
    }

    editConfiguration(item: OM.ProductionPhaseConfigurationVM) {
        if(!item){
            item = new OM.ProductionPhaseConfigurationVM();
        }

        this.$opModal.show(EditModal, {
            model: item,
            callback: (updatedModel: OM.ProductionPhaseConfigurationVM) => {
                ProductionPhaseConfigurationClient.editConfiguration(updatedModel)
                .then(x => {
                    this.init();
                    this.$opModal.closeLast();
                })
                .catch(y => {
                    this.$opModal.show(InfoModal, {
                        text: this.$localizationService.getLocalizedValue("Error", "Error"),
                        subtitle: y.Message,
                        deny: this.$localizationService.getLocalizedValue("Close", "Close"),
                        denyCb: () => {
                            this.$opModal.closeLast();
                        }
                    })
                })
            }
        })
    }

}
